module.exports = __webpack_public_path__ + "img/project-banner3.e0a91ae3.jpg";